import { render, staticRenderFns } from "./SponsorsForm.vue?vue&type=template&id=7261f63c&"
import script from "./SponsorsForm.vue?vue&type=script&lang=js&"
export * from "./SponsorsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports